import { takeLatest, put } from "redux-saga/effects";
import {
  FETCH_SYNTHESE_ANNEE_REQUEST,
  REDIRECT_TO_LOGIN,
} from "./actionsTypes";
import {
  fetchSyntheseAnneeSuccess,
  fetchSyntheseFailure,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchSyntheseAnnee(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;

  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_synthese_annee_en_cours`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchSyntheseAnneeSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* syntheseAnneeSaga() {
  yield takeLatest(FETCH_SYNTHESE_ANNEE_REQUEST, fetchSyntheseAnnee);
}

export default syntheseAnneeSaga;
